import { render, staticRenderFns } from "./ChecklistsCrud.vue?vue&type=template&id=71a9eed0"
import script from "./ChecklistsCrud.vue?vue&type=script&lang=js"
export * from "./ChecklistsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports